<!-- Backdrop (mobile) -->
<div class="faq-backdrop" *ngIf="isOpen" (click)="close()"></div>

<!-- Languette du bord droit (comme Majelan Bot sur Majelan web) : ouvre / ferme l'aide -->
<button type="button"
        class="faq-edge-tab"
        *ngIf="isLoggedIn"
        [class.open]="isOpen"
        (click)="toggle()"
        [attr.aria-expanded]="isOpen"
        [title]="edgeTabTitle"
        [attr.aria-label]="edgeTabTitle">
  <app-icon [name]="isOpen ? 'x' : 'help-circle'" size="sm"></app-icon>
</button>

<!-- Panel -->
<div class="faq-panel" [class.open]="isOpen" role="dialog" aria-label="FAQ">

  <!-- Panel Header -->
  <div class="panel-header">
    <div class="panel-title">
      <span class="panel-emoji"><app-icon name="message-circle" size="sm"></app-icon></span>
      <div>
        <span class="panel-name">Aide & FAQ</span>
        <span class="panel-sub">Trouvez rapidement une réponse</span>
      </div>
    </div>
    <button class="panel-close" (click)="close()" title="Fermer">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <!-- Search -->
  <div class="panel-search">
    <div class="search-pill" [class.active]="searchFocused">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input
        type="text"
        placeholder="Rechercher…"
        class="search-input"
        [ngModel]="searchQuery"
        (ngModelChange)="onSearchChange($event)"
        (focus)="searchFocused = true"
        (blur)="searchFocused = false"
      />
      <button class="clear-btn" *ngIf="searchQuery" (click)="clearSearch()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div class="panel-state" *ngIf="isLoading">
    <div class="spinner"></div>
    <span>Chargement…</span>
  </div>

  <!-- Empty -->
  <div class="panel-state" *ngIf="!isLoading && categories.length === 0 && searchQuery">
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
    <span>Aucun résultat pour <strong>{{ searchQuery }}</strong></span>
  </div>

  <!-- FAQ Content -->
  <div class="panel-body" *ngIf="!isLoading && categories.length > 0">
    <div class="faq-group" *ngFor="let cat of categories; let ci = index">

      <button class="group-btn" (click)="toggleCategory(ci)">
        <span class="group-emoji">{{ getIconEmoji(cat.icon) }}</span>
        <span class="group-name">{{ cat.category }}</span>
        <svg class="arrow" [class.open]="isCategoryExpanded(ci)" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      <div class="group-items" *ngIf="isCategoryExpanded(ci)">
        <div class="faq-item" *ngFor="let item of cat.items; let ii = index" [class.item-open]="isItemExpanded(ci, ii)">
          <button class="item-q" (click)="toggleItem(ci, ii)">
            <span class="q-dot"></span>
            <span class="q-text">{{ item.question }}</span>
            <svg class="arrow-sm" [class.open]="isItemExpanded(ci, ii)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
          <div class="item-a" *ngIf="isItemExpanded(ci, ii)">
            <div class="a-text" [innerHTML]="renderMarkdown(item.answer)"></div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
